import React, { useState, useEffect, useCallback, useMemo } from 'react'
import _ from 'lodash'
import debounce from 'lodash/debounce'
import { message, Button, Modal } from 'antd'
import { FaUsers } from 'react-icons/fa'
import http from '../../../../../services/api/http'
import { api } from '../../../../../services'
import { AddParticipant } from '../AntMediaService/internal'

import EventMenus from '../EventMenus'
import { Spinner } from '../../../../../components'
import './teamstyles.scss'
function TeamConference(props) {
  const reqURLTeams = `events/${props.eventId}/teams/`
  const eventTitle = `event_${props.eventId}`

  const [confErrorMsg, setConfErrorMsg] = useState('')
  const [isLoading, setLoading] = useState(false)

  const [isJoined, setIsJoined] = useState(false)
  const [showParticipant, setShowParticipant] = useState(false)
  const [successInvitation, setSuccessInvitation] = useState(false)
  const [failInvitation, setFailInvitation] = useState(false)
  const [confFailed, setConfFailed] = useState(false)
  const [emailList, setEmailList] = useState([])
  const [initialEmails, setInitialEmails] = useState([])
  const [emails, setEmails] = useState([])
  const [inviting, setInviting] = useState(false)
  const [fetchingEmail, setFetchingEmail] = useState(false)
  const [canShowModal, setShowModal] = useState(false)
  const [canShowEndModal, setShowEndModal] = useState(false)

  const [eventStartTime, setEventStartTIme] = useState(null)
  const [teamsJoined, setTeamsJoined] = useState(false)
  const [teamsJoinUrl, setTeamsJoinUrl] = useState('')

  useEffect(() => {
    const { hostEmails, isHandRaised, App, userId } = props
    setInitialEmails(hostEmails)
    setEmails(hostEmails)
    return () => {
      if (isHandRaised) {
        App.declineToAsk(userId)
      }
    }
  }, [])

  useEffect(() => {
    const { userOrg } = props
    setFetchingEmail(true)
    api.organizations.getUsersByOrganizationId(userOrg).then(res => {
      const allEmails = res.data
        .map(val => {
          const userOrg = val.user
          const dataValue = {
            text: userOrg && userOrg.email,
            value: userOrg && userOrg.email
          }
          return dataValue
        })
        .filter(item => item.value !== null)

      setEmailList(allEmails)
      setFetchingEmail(false)
    })
  }, [])

  // When event timer start time is received
  useEffect(() => {
    if (eventStartTime) {
      console.log('event time is changed in effect')
      props.onEventTime(eventStartTime)
    }
  }, [eventStartTime])

  // When join button is clicked
  useEffect(() => {
    if (props.onJoin) {
      startEvent()
    }
  }, [props.onJoin])

  // When invite button is clicked in participants
  useEffect(() => {
    if (props.App.state.isInvite) {
      if (
        props.event &&
        props.event.event_type === 'webinar' &&
        initialEmails &&
        initialEmails.length >= 5
      ) {
        message.error(
          'You have reached the maximum number of participants for this event'
        )
        if (props.App.onInvite) {
          props.App.onInvite()
        }
      } else {
        showAddparticipant()
      }
    }
  }, [props.App.state.isInvite])

  useEffect(() => {
    if (inviting) {
      const { event, eventId } = props
      const newAdded = _.difference(emails, initialEmails)

      const data = {
        title: event.title,
        add_participant: newAdded,
        cover_id: event.cover_id
      }
      api.events
        .updateById(eventId, data)
        .then(response => {
          const { data: respData } = response
          setInviting(false)
          setSuccessInvitation(true)
          setInitialEmails(respData.host_emails)
          showAddparticipant()
        })
        .catch(() => {
          setInviting(false)
          setFailInvitation(true)
          setEmails(emails)
          setTimeout(() => {
            setFailInvitation(false)
          }, 3000)
        })
    }
  }, [inviting])

  const startEvent = async () => {
    const {
      userId,
      username,
      handleBroadcastChange,
      isConferenceHost,
      setTeamTabOpenn,
      eventId
    } = props
    setLoading(true)
    handleBroadcastChange()

    const payload = {
      title: eventTitle,
      name: isConferenceHost
        ? `${username}#${userId}`
        : `passive${username}#${userId}`,
      region: 'us-east-1'
    }

    try {
      const response = await http({
        method: 'PUT',
        url: reqURLTeams + 'join',
        data: payload
      })

      if (response && response.data?.JoinInfo?.join_url) {
        const joinUrl = response.data.JoinInfo.join_url
        setTeamsJoinUrl(joinUrl)
        const newTab = window.open(joinUrl, '_blank')
        if (newTab) {
          newTab.focus()
        }
        message.success('Teams meeting opened in new tab')
        // Set success state
        setTimeout(() => {
          setTeamTabOpenn(true)
          setLoading(false)
          setTeamsJoined(true)
          handleBroadcastChange()
        }, 2000)
      } else {
        message.error('Failed to get Teams meeting URL')
        setLoading(false)
        handleBroadcastChange()
      }
    } catch (error) {
      console.log('Error joining Teams meeting: ', error.message)
      message.error('Failed to join the Teams meeting. Please try again.')
      setLoading(false)
      handleBroadcastChange()
    }
  }

  const leaveEvent = async () => {
    const {
      handleBroadcastChange,
      onLeaveEvent,
      userId,
      isHandRaised,
      event
    } = props

    if (isHandRaised) {
      App.declineToAsk(userId)
    }
    App.onHeaderItemClick()
    setConfFailed(false)
    setConfErrorMsg('')
    onLeaveEvent()
    setShowModal(false)
    setIsJoined(false)

    // Simple cleanup for Teams events
    message.info('Teams meeting closed')

    checkCondition()
    await handleBroadcastChange()
  }

  const endEvent = async () => {
    const { handleBroadcastChange, App, event } = props

    App.onHeaderItemClick()
    setShowEndModal(false)
    setShowModal(false)
    setIsJoined(false)

    // Simple end for Teams events
    message.info('Teams meeting ended')
    await handleBroadcastChange()
    checkEndCondition()
  }

  const checkCondition = () => {
    const {
      event: { parent_breakout_room }
    } = props
    console.log('checkCondition', parent_breakout_room)
    if (parent_breakout_room) {
      window.location.replace(`/events/${parent_breakout_room}`)
    }
  }

  const checkEndCondition = () => {
    const {
      event: { parent_breakout_room }
    } = props
    console.log('checkEndCondition', parent_breakout_room)
    if (parent_breakout_room) {
      window.location.replace(`/events/${parent_breakout_room}`)
    }
  }

  const toggleModal = () => {
    setShowModal(!canShowModal)
  }

  const toggleEndModal = () => {
    setShowEndModal(!canShowEndModal)
  }

  const showAddparticipant = () => {
    setShowParticipant(!showParticipant)
    setSuccessInvitation(false)
    if (showParticipant) {
      props.App.onInvite()
    }
  }

  const sendInvitations = () => {
    setInviting(true)
  }

  const fetchUserEmails = useCallback(
    debounce(value => {
      setEmailList([])
      setFetchingEmail(true)
    }, 1000),
    []
  )

  const handleEmailChange = selectedValue => {
    setEmails(selectedValue)
  }

  const {
    isConferenceHost,
    t,
    isConfCreator,
    allowJoin,
    App,
    isConferenceParticipant,
    allowedUser: raiseHandAllowed,
    isHandRaised,
    raiseHandRequesting,
    userId,
    count
  } = props

  const isMaxParticipants = useMemo(() => {
    return (
      props.event &&
      props.event.event_type === 'webinar' &&
      initialEmails &&
      initialEmails.length >= 5
    )
  }, [props.event, initialEmails])

  return (
    <div>
      {confFailed && confErrorMsg && message.error(confErrorMsg)}
      {failInvitation && message.error('Please try again.')}
      {successInvitation &&
        message.success(
          'Your invitation sent successfully. Participant(s) will get notification in their email'
        )}

      {/* Simple loading state for Teams events */}
      {isLoading && props.event.event_type === 'coaching_session' && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '200px',
            gap: '16px',
            marginTop: '24px'
          }}
        >
          <Spinner />
          <p>Joining Teams meeting...</p>
        </div>
      )}

      {/* Simple success state for Teams events */}
      {!isLoading &&
        teamsJoined &&
        props.event.event_type === 'coaching_session' && (
          <div className="teams-success-container">
            <div className="teams-success-icon">
              <FaUsers />
            </div>
            <h3 className="teams-success-title">Teams Meeting Joined</h3>
            <p className="teams-success-description">The Teams meeting has been opened in a new tab.</p>
            <p className="teams-success-redirect">
              You will be automatically redirected. If you are not automatically redirected, please <a href={teamsJoinUrl} target="_blank" rel="noopener noreferrer" className="teams-redirect-link">click here</a>.
            </p>
            <p className="teams-success-info">
              You can close this window and continue with the meeting in the new
              tab.
            </p>
            <Button
              type="primary"
              shape="round"
              className="teams-close-button"
              onClick={() => {
                leaveEvent()
                props.setTeamTabOpenn(false)
                setLoading(false)
                setIsJoined(false)
                setConfFailed(false)
                setConfErrorMsg('')
                setTeamsJoined(false)
                props.handleBroadcastChange()
              }}
            >
              Close
            </Button>
          </div>
        )}

      {allowJoin && props.event.event_type === 'coaching_session' && (
        <>
          <div className={`${isJoined ? 'controller-items' : ''}`}>
            {isJoined && (
              <EventMenus
                count={count}
                isAudio={true}
                show={App.state.show}
                isVideo={true}
                isGridActive={false}
                raiseHandAllowed={raiseHandAllowed}
                isHandRaised={isHandRaised}
                raiseHandRequesting={raiseHandRequesting}
                isConfCreator={isConfCreator}
                isRecording={props.event.is_recording}
                isConferenceHost={isConferenceHost}
                isScreenSharing={false}
                isBreakoutRoom={props.event.has_breakout_room}
                isConferenceParticipant={isConferenceParticipant}
                isRemoteScreenSharing={false}
                onLeave={toggleModal}
                onClickMute={() => {}}
                onClickVideo={() => {}}
                onEndForAll={toggleEndModal}
                onScreenShare={() => {}}
                onClickBreakoutRooms={params => {
                  App.onHeaderItemClick(params)
                  App.onBreakoutRoom(
                    isConfCreator && props.event.has_breakout_room
                  )
                }}
                onClickParticipants={params => App.onHeaderItemClick(params)}
                onClickFullScreen={() => {}}
                onClickGrid={() => {}}
                onHandRaise={App.handleRaiseHand}
                onExitHandRaise={() => App.declineToAsk(userId)}
                isWhiteboardSharing={false}
                onClickWhiteboardSharing={() => {}}
                eventStartTime={eventStartTime}
                consumerId={null}
                userId={userId}
              />
            )}
          </div>
          {canShowModal && (
            <Modal
              title={t('labels:alert')}
              visible={canShowModal}
              onOk={() => leaveEvent()}
              onCancel={toggleModal}
            >
              <h3>
                {props.hasBreakoutRoom
                  ? t('events:event_breakout_leave')
                  : t('events:event_modal_warn')}
              </h3>
            </Modal>
          )}
          {canShowEndModal && (
            <Modal
              title={t('labels:alert')}
              visible={canShowEndModal}
              onOk={() => endEvent()}
              onCancel={toggleEndModal}
            >
              <h3>
                {props.hasBreakoutRoom
                  ? t('events:event_breakout_end')
                  : t('events:event_end_warn')}
              </h3>
            </Modal>
          )}
          {showParticipant && !isMaxParticipants && (
            <Modal
              title={t('v2:add_participants')}
              visible={showParticipant}
              onOk={sendInvitations}
              onCancel={showAddparticipant}
              footer={[
                <Button key="back" onClick={showAddparticipant}>
                  {t('buttons:cancel')}
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  loading={inviting}
                  onClick={sendInvitations}
                >
                  {t('v2:send_invitations')}
                </Button>
              ]}
            >
              <AddParticipant
                emailList={emailList}
                emails={emails}
                fetchUserEmails={fetchUserEmails}
                handleEmailChange={handleEmailChange}
                fetching={fetchingEmail}
                invitedEmails={initialEmails}
                event={props.event}
                t={t}
              />
            </Modal>
          )}
        </>
      )}
    </div>
  )
}

export default TeamConference
